import * as yup from "yup";

const schema = yup.object().shape({
  scriptName: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters")
    .required("Name is required"),
  scriptSkill: yup
    .string()
    .nullable(true)
    .when("scriptGlobal", {
      is: false,
      then: yup
        .string()
        .nullable(true)
        .required("Select skill or enable global mode"),
      otherwise: yup.string().nullable(true),
    }),
  scriptGlobal: yup.boolean().required("Global is required"),
  //scriptType: yup.string().required("Tipo é obrigatório por favor selecione uma skill ou modo global"),
  scriptText: yup.string().required("Text is required"),
  scriptActivated: yup.boolean().required("Activated is required"),

  scriptFiles: yup.object().shape({
    data: yup.string(),
    mimeType: yup.string(),
    fileName: yup.string(),
  })
});

export default schema; 
